export const servicesData = [
  {
    id: 1,
    icon: 'ri-plane-line',
    title: 'Transport Aérien vers l\'Afrique',
    description: 'Solutions rapides et sécurisées pour vos envois urgents vers toute l\'Afrique avec suivi en temps réel.',
    link: '/services#aerien',
  },
  {
    id: 2,
    icon: 'ri-ship-line',
    title: 'Transport Maritime',
    description: 'Fret maritime économique pour vos marchandises volumineuses avec départs réguliers vers les ports africains.',
    link: '/services#maritime',
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: 'Groupage de Marchandises',
    description: 'Optimisez vos coûts avec notre service de groupage pour petits et moyens volumes vers l\'Afrique.',
    link: '/services#groupage',
  },
  {
    id: 4,
    icon: 'ri-building-line',
    title: 'Stockage & Entreposage',
    description: 'Entrepôts sécurisés et modernes pour le stockage temporaire ou longue durée de vos marchandises.',
    link: '/services#stockage',
  },
  {
    id: 5,
    icon: 'ri-global-line',
    title: 'Import / Export',
    description: 'Gestion complète de vos opérations d\'import-export avec assistance douanière et administrative.',
    link: '/services#import-export',
  },
  {
    id: 6,
    icon: 'ri-server-line',
    title: 'Solutions Informatiques',
    description: 'Conseil, maintenance et développement de solutions numériques pour optimiser votre logistique.',
    link: '/services#informatique',
  },
];

export const whyChooseUsData = [
  {
    id: 1,
    icon: 'ri-time-line',
    title: 'Fiabilité Garantie',
    description: 'Respect strict des délais avec un taux de ponctualité de 98% sur toutes nos expéditions.',
  },
  {
    id: 2,
    icon: 'ri-map-pin-line',
    title: 'Traçabilité Totale',
    description: 'Suivez vos marchandises en temps réel grâce à notre système de tracking avancé.',
  },
  {
    id: 3,
    icon: 'ri-puzzle-line',
    title: 'Solutions Sur Mesure',
    description: 'Chaque projet est unique, nous adaptons nos services à vos besoins spécifiques.',
  },
  {
    id: 4,
    icon: 'ri-customer-service-line',
    title: 'Support 24/7',
    description: 'Notre équipe est disponible jour et nuit pour répondre à toutes vos questions.',
  },
];

export const destinationsData = [
  {
    id: 1,
    region: 'Afrique de l\'Ouest',
    cities: ['Dakar', 'Abidjan', 'Lagos', 'Accra', 'Conakry'],
    delay: '5-7 jours',
    frequency: 'Hebdomadaire',
  },
  {
    id: 2,
    region: 'Afrique Centrale',
    cities: ['Douala', 'Kinshasa', 'Brazzaville', 'Libreville', 'Yaoundé'],
    delay: '6-8 jours',
    frequency: 'Bi-hebdomadaire',
  },
  {
    id: 3,
    region: 'Afrique de l\'Est',
    cities: ['Nairobi', 'Dar es Salaam', 'Addis-Abeba', 'Kampala'],
    delay: '7-9 jours',
    frequency: 'Hebdomadaire',
  },
];

export const services = [
  {
    id: 1,
    icon: 'ri-plane-line',
    title: 'Transport Aérien vers l\'Afrique',
    description: 'Solutions rapides et sécurisées pour vos envois urgents vers toute l\'Afrique avec suivi en temps réel et garantie de délais.',
    image: 'https://public.readdy.ai/ai/img_res/89c6b083c182aea0893525b18dc56dfa.jpg',
    features: [
      'Départs hebdomadaires garantis',
      'Suivi en temps réel 24h/24',
      'Livraison express en 48-72h',
      'Assistance douanière incluse',
    ],
  },
  {
    id: 2,
    icon: 'ri-ship-line',
    title: 'Transport Maritime',
    description: 'Fret maritime économique pour vos marchandises volumineuses avec départs réguliers vers les ports africains.',
    image: 'https://readdy.ai/api/search-image?query=cargo%20ship%20maritime%20freight%20transport%20containers%20ocean%20shipping%20port%20logistics%20professional%20commercial%20vessel&width=600&height=400&seq=service-maritime-2&orientation=landscape',
    features: [
      'Conteneurs FCL et LCL disponibles',
      'Départs bi-hebdomadaires',
      'Tarifs compétitifs',
      'Couverture assurance complète',
    ],
  },
  {
    id: 3,
    icon: 'ri-stack-line',
    title: 'Groupage de Marchandises',
    description: 'Optimisez vos coûts avec notre service de groupage pour petits et moyens volumes vers l\'Afrique.',
    image: 'https://readdy.ai/api/search-image?query=warehouse%20groupage%20cargo%20consolidation%20logistics%20boxes%20pallets%20organized%20storage%20professional%20freight%20handling&width=600&height=400&seq=service-groupage-3&orientation=landscape',
    features: [
      'Mutualisation des coûts de transport',
      'Idéal pour petits volumes',
      'Départs réguliers programmés',
      'Emballage et palettisation inclus',
    ],
  },
  {
    id: 4,
    icon: 'ri-building-line',
    title: 'Stockage & Entreposage',
    description: 'Entrepôts sécurisés et modernes pour le stockage temporaire ou longue durée de vos marchandises.',
    image: 'https://readdy.ai/api/search-image?query=modern%20warehouse%20storage%20facility%20organized%20shelves%20logistics%20inventory%20management%20professional%20clean%20industrial%20interior&width=600&height=400&seq=service-stockage-4&orientation=landscape',
    features: [
      'Entrepôts sécurisés 24h/24',
      'Gestion informatisée des stocks',
      'Stockage courte et longue durée',
      'Accès flexible à vos marchandises',
    ],
  },
  {
    id: 5,
    icon: 'ri-global-line',
    title: 'Import / Export',
    description: 'Gestion complète de vos opérations d\'import-export avec assistance douanière et administrative.',
    image: 'https://readdy.ai/api/search-image?query=international%20trade%20import%20export%20customs%20clearance%20documents%20logistics%20global%20business%20professional%20office&width=600&height=400&seq=service-import-export-5&orientation=landscape',
    features: [
      'Dédouanement complet',
      'Gestion des documents officiels',
      'Conformité réglementaire',
      'Conseil en commerce international',
    ],
  },
  {
    id: 6,
    icon: 'ri-server-line',
    title: 'Solutions Informatiques',
    description: 'Conseil, maintenance et développement de solutions numériques pour optimiser votre logistique.',
    image: 'https://readdy.ai/api/search-image?query=modern%20IT%20solutions%20software%20development%20logistics%20technology%20digital%20transformation%20professional%20computer%20office%20clean&width=600&height=400&seq=service-informatique-6&orientation=landscape',
    features: [
      'Logiciels de gestion logistique',
      'Tracking et traçabilité digitale',
      'Intégration ERP et WMS',
      'Support technique dédié',
    ],
  },
];
